var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifiche(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_105_8015)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6519 20.3214V11.6429C22.6519 7.38073 19.2276 3.92859 14.9998 3.92859C10.7719 3.92859 7.34759 7.38073 7.34759 11.6429V20.3214L4.47803 23.2143V24.1786H25.5215V23.2143L22.6519 20.3214Z",
    stroke: "#5e6065",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8695 25.625C17.8695 27.2257 16.5878 28.5179 14.9999 28.5179C13.4121 28.5179 12.1304 27.2257 12.1304 25.625",
    stroke: "#5e6065",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 1.51782V2.96425",
    stroke: "#5e6065",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_105_8015"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifiche);
export default __webpack_public_path__ + "static/media/notifiche.082e754aab754a4a46cf93e7cf7b171b.svg";
export { ForwardRef as ReactComponent };